var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grid grid-1"},[(_vm.data[_vm.data.type])?_c(_vm.components[_vm.data.type],{tag:"component",class:_vm.cols,attrs:{"data":Object.assign(_vm.data[_vm.data.type], { lazyload: true, ratio: 'auto', object_fit: _vm.data.object_fit ? 'cover' : 'contain', layout: _vm.data.layout, embed: true })}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }